import React, { useEffect, useState, Fragment } from 'react'

import { useRouter } from 'next/router'

import ACarousel from '@nexys/components/ACarousel'
import Text from '@nexys/components/Typography/Text'
import Title from '@nexys/components/Typography/Title'
import { Col, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { icon } from 'constant'

import classNames from './hero.module.scss'

export default function Hero({ articleData }) {
  const { xs, sm, lg } = useBreakpoint()

  const { push } = useRouter()
  const slicedArticles = articleData?.filter(
    (article) => article.type === 'main-banner',
  )

  const [selectedArticle, setSelectedArticle] = useState(null)

  useEffect(() => {
    if (slicedArticles?.length > 0) setSelectedArticle(slicedArticles[0])
  }, [slicedArticles?.length])

  return (
    <Fragment>
      {
        slicedArticles?.length ? (
          <div className={classNames.container}>
            <img
              src={icon.RectangleGroupSVG}
              alt="icon"
              className={classNames.iconGroup}
            />
            <div className={classNames.left}>
              <span className={classNames.title}>{selectedArticle?.tittle}</span>
              <span className={classNames.shortDesc}>{selectedArticle?.shortDesc}</span>
              <div
                onClick={() =>
                  push(`/information/${selectedArticle?.tittle?.split(' ')?.join('-')}`)
                }
                onKeyDown={() =>
                  push(`/information/${selectedArticle?.tittle?.split(' ')?.join('-')}`)
                }
                role="button"
                className={`flex items-center cursor-pointer mt-5 ${classNames.infoBtn}`}
              >
                <span className={classNames.info}>
                  Selengkapnya
                </span>
                <img
                  src={icon.ArrowSVG}
                  alt="arrow"
                  className={classNames.arrow}
                />
              </div>
            </div>
            <div className={classNames.right}>
              <ACarousel
                data={slicedArticles}
                setSelectedSlide={(data) => setSelectedArticle(data)}
                autoplay={true}
              />
            </div>
          </div>
        ) : <></>
      }
    </Fragment>
  )
}